import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { ConfirmModal } from 'components/dialog/ModalTemplate'
import TextInput from 'components/form/TextInput'
import { Modal } from 'components/dialog/Modals'
import useValidator from 'utils/hooks/useValidator'
import { alternativeKeywordRegex, isEmpty } from 'utils'
import ErrorText from 'components/form/ErrorText'

const AlternativeKeywordModal = ({ on, handleConfirm, handleClose }) => {
  const MAX_KEYWORD_LENGTH = 7
  const [alternativeKeyword, setAlternativeKeyword] = useState('')
  const { errors, validate, clearError } = useValidator(
    () => ({
      alternativeKeyword: isEmpty(alternativeKeyword)
        ? '대체키워드를 입력하세요.'
        : (alternativeKeyword.length > MAX_KEYWORD_LENGTH &&
            `${MAX_KEYWORD_LENGTH}자이하로 입력하셔야 합니다.`) ||
          (!alternativeKeywordRegex.test(alternativeKeyword) &&
            '입력 불가능한 문자가 입력되어 있습니다. (특수문자 일부, 한자 입력 불가능)'),
    }),
    [alternativeKeyword]
  )

  useEffect(() => {
    setAlternativeKeyword('')
  }, [on])

  const onConfirm = async ({ preventClose }) => {
    try {
      setAlternativeKeyword(alternativeKeyword.trim())
      await validate()
      handleConfirm(alternativeKeyword)
      clearError()
      setAlternativeKeyword('')
      handleClose()
    } catch (ignore) {
      preventClose()
    }
  }

  const handleSubmit = e => {
    e.preventDefault()
  }

  return (
    <Modal className="keyword_layer" on={on}>
      <ConfirmModal
        title="키워드 삽입"
        onConfirm={onConfirm}
        handleClose={() => {
          handleClose()
          clearError()
        }}>
        <p className="subtit_layer">
          사용자가 검색한 키워드를 소재의 문안에 포함시켜 소재를 노출할 수 있는
          기능입니다.
        </p>
        <form onSubmit={handleSubmit}>
          <fieldset>
            <legend className="screen_out">키워드 입력 폼</legend>
            <table className="tbl_layer">
              <caption className="hide_caption">키워드 입력 표</caption>
              <colgroup>
                <col width="161" />
                <col />
              </colgroup>
              <tbody>
                <tr className="tr_box">
                  <th scope="row">대체키워드</th>
                  <td>
                    <div className="inner_cell">
                      <TextInput
                        placeholder="대체키워드를 입력하세요"
                        maxLength={7}
                        value={alternativeKeyword}
                        onValueChange={setAlternativeKeyword}
                        error={errors.alternativeKeyword}
                        showError
                      />
                      <ErrorText error={errors.alternativeKeyword} />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="info_append">
              키워드가 포함된 문안이 허용된 길이를 초과할 경우 대체 키워드가
              노출됩니다.
              <br />
              키워드삽입 기능을 사용하실 경우,{' '}
              <span className="fc_emph">대체 키워드</span>를 반드시 입력하셔야
              합니다.
              <br />
              <strong>병/의원 광고</strong>는 의료광고 사전심의대상으로 키워드
              삽입 기능을 사용할 수 없습니다.
            </div>
            <p className="subtit_layer">예시</p>
            <div className="info_keyword">
              <strong className="tit_info">• 검색키워드를 노출하는 경우</strong>
              <dl>
                <dt>키워드</dt>
                <dd>
                  <span className="fc_emph">꽃배달50%할인</span>
                </dd>
                <dt>제목</dt>
                <dd>
                  <span className="fc_emph">꽃배달50%할인</span> OO플라워
                  <span className="fc_info"> (15자 이내)</span>
                </dd>
                <dt>설명문구</dt>
                <dd>
                  <span className="fc_emph">꽃배달50%할인</span>, 2시간 당일배송
                  꽃바구니, 동양란, 화분, 화환 계산서
                  <span className="fc_info"> (45자 이내)</span>
                </dd>
              </dl>
              <strong className="tit_info">
                • 대체키워드를 노출하는 경우 (대체키워드:{' '}
                <span className="fc_warn">꽃배달할인</span>)
              </strong>
              <dl>
                <dt>키워드</dt>
                <dd>
                  <span className="fc_emph">꽃배달서비스60%할인</span>
                </dd>
                <dt>제목</dt>
                <dd>
                  <span className="fc_warn">꽃배달할인</span> OO플라워
                  <span className="fc_info">
                    {' '}
                    (“꽃배달서비스60%할인” 사용 시 15자 초과로 대체키워드 활용)
                  </span>
                </dd>
                <dt>설명문구</dt>
                <dd>
                  <span className="fc_emph">꽃배달서비스60%할인</span>, 2시간
                  당일배송 꽃바구니, 동양란, 화분, 화환 계산서
                  <span className="fc_info"> (45자 이내)</span>
                </dd>
              </dl>
            </div>
          </fieldset>
        </form>
      </ConfirmModal>
    </Modal>
  )
}

export default AlternativeKeywordModal

AlternativeKeywordModal.propTypes = {
  handleConfirm: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  on: PropTypes.bool.isRequired,
}
